module.exports = __webpack_public_path__ + "static/beans02-bbfa1c4ea404a5d57cef5fab1a239928.png";